import React from 'react';

interface TransparentMascotCharacterProps {
  className?: string;
  onLoadedData?: () => void;
  onCanPlay?: () => void;
}

export const TransparentMascotCharacter: React.FC<TransparentMascotCharacterProps> = ({
  className = '',
  onLoadedData,
  onCanPlay,
}) => {
  const handleLoad = () => {
    onLoadedData?.();
    onCanPlay?.();
  };

  return (
    <div className={`relative inline-block overflow-hidden ${className}`}>
      <img
        src="/video/scrudixmascot_transparent.webp"
        alt="Scrudix Mascot Character"
        onLoad={handleLoad}
        className="w-full h-full object-contain pointer-events-none select-none drop-shadow-sm"
        loading="eager"
        decoding="async"
      />
    </div>
  );
};

export default TransparentMascotCharacter;

